/**
 * Alphabetical comparison for French labels: case and accent insensitive, so
 * 'Élan' sits with the E's and not after Z. Empty values are pushed last.
 *
 * Kept apart from `sortByName`, which drops nameless entries and compares with
 * `<`: changing it would silently reorder its existing callers.
 */
export const compareNames = (a?: string, b?: string): number => {
  if (!a) {
    return b ? 1 : 0;
  }
  if (!b) {
    return -1;
  }
  return a.localeCompare(b, 'fr', { sensitivity: 'base' });
};

export const sortByName = (array: any[]) => {
  return array
    .filter(v => {
      return !!v['name'];
    })
    .sort((v1, v2) => {
      return v1['name'] < v2['name'] ? -1 : 1;
    });
};
